var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCareer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.91h-1.5v-.728C16.5.979 15.49 0 14.25 0h-7.5C5.51 0 4.5.98 4.5 2.182v.727H3c-1.655 0-3 1.305-3 2.91v7.272C0 14.695 1.345 16 3 16h15c1.655 0 3-1.305 3-2.91V5.819c0-1.604-1.345-2.909-3-2.909zM6 2.181c0-.402.336-.727.75-.727h7.5c.414 0 .75.325.75.727v.727H6v-.727zM19.5 13.09c0 .803-.672 1.454-1.5 1.454H3c-.828 0-1.5-.651-1.5-1.454V5.818c0-.803.672-1.454 1.5-1.454h1.5v2.181c0 .402.336.728.75.728S6 6.947 6 6.545V4.364h9v2.181c0 .402.336.728.75.728s.75-.326.75-.728V4.364H18c.828 0 1.5.651 1.5 1.454v7.273z",
    fill: "#FCBB00",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCareer);
export default __webpack_public_path__ + "static/media/ico_career.797f2eb25fa5b1d91b5c6c4edfc39bc2.svg";
export { ForwardRef as ReactComponent };